// 260911nrai: CR list "Alle" + bulk actions on client tab (do_submit/toggle_marks
// live only on the standalone CR index and collide with the client person form).

let crBulkCloseMarksForm = null;

function crMarksFormFrom(element) {
  if (!element) {
    return null;
  }
  if (element.tagName === 'FORM') {
    return element;
  }
  return element.closest('form');
}

function crMarkCheckboxes(form) {
  if (!form) {
    return [];
  }
  return Array.from(form.querySelectorAll('input.cr-mark-checkbox[type="checkbox"]'));
}

function crCountMarked(form) {
  const boxes = crMarkCheckboxes(form);
  return {
    total: boxes.length,
    checked: boxes.filter((box) => box.checked).length
  };
}

function crSyncSelectAll(form) {
  const selectAll = form && form.querySelector('.cr-marks-select-all');
  if (!selectAll) {
    return;
  }
  const counts = crCountMarked(form);
  selectAll.checked = counts.total > 0 && counts.checked === counts.total;
  selectAll.indeterminate = counts.checked > 0 && counts.checked < counts.total;
}

/**
 * Toggle every active-CR row checkbox in the marks form from the header "Alle" box.
 *
 * @param {HTMLInputElement} selectAllCheckbox
 */
function crToggleMarks(selectAllCheckbox) {
  const form = crMarksFormFrom(selectAllCheckbox);
  if (!form) {
    return;
  }
  const checked = !!selectAllCheckbox.checked;
  crMarkCheckboxes(form).forEach((box) => {
    box.checked = checked;
  });
  selectAllCheckbox.indeterminate = false;
}

/**
 * Confirm bulk CR actions (close / primary / join sequences).
 * Close-all uses a modal instead of the old confirm() hint.
 *
 * @param {HTMLFormElement} form
 * @param {string} action
 * @return {boolean}
 */
function crMarksFinalCheck(form, action) {
  let errors = 0;
  let errorMsg = '';

  if (action === 'toggle_status' || action === 'set_primary_cr') {
    const actionText = action === 'toggle_status'
      ? 'deaktivieren'
      : 'als Fallführend/BezugsbetreuerIn ändern ';
    const counts = crCountMarked(form);

    if (counts.checked === 0) {
      errorMsg += 'Markieren Sie zuerst Einträge aus der Liste, die Sie ' + actionText + ' wollen.';
      errors += 1;
    }
    if (counts.checked > 10 && action !== 'toggle_status') {
      if (!confirm('Sie haben mehr als 10 Einträge markiert. Wollen Sie wirklich alle ' + actionText + '?')) {
        errors += 1;
      }
    }
  } else if (action === 'join_sequences') {
    const fromChecked = form.querySelectorAll('input[name="from_sequences[]"]:checked').length;
    if (fromChecked === 0) {
      errorMsg += 'Markieren Sie zuerst die Sequenzen, DIE Sie zusammenfassen wollen.\n';
      errors += 1;
    } else if (!confirm('Sind Sie sicher, dass Sie die Sequenzen zusammenführen, und die AUF DIESE Sequenz den anderen Zuständigkeiten zuordnen wollen, sowie alle Datenblätter außer jenes der AUF DIESE Sequenz löschen wollen?')) {
      errors += 1;
    }
  }

  if (errors > 0 && errorMsg !== '') {
    alert(errorMsg);
  }
  return errors === 0;
}

function crMarksSubmitAjax(form) {
  if (typeof SetPageToBusy === 'function') {
    SetPageToBusy();
  }
  window.jQuery.ajax({
    url: form.getAttribute('action'),
    method: form.getAttribute('method') || 'POST',
    data: window.jQuery(form).serialize(),
    dataType: 'script'
  }).fail(function () {
    if (typeof SetPageToIdle === 'function') {
      SetPageToIdle();
    }
    alert('Die ausgewählten Zuständigkeiten konnten nicht aktualisiert werden.');
  });
}

function crMarksDoSubmit(form, action) {
  const actionField = form.querySelector('[name="the_action"]');
  if (actionField) {
    actionField.value = action;
  }

  const ajaxSubmit = form.getAttribute('data-cr-marks-ajax') === 'true';
  if (ajaxSubmit && window.jQuery) {
    crMarksSubmitAjax(form);
  } else {
    if (typeof SetPageToBusy === 'function') {
      SetPageToBusy();
    }
    form.submit();
  }
}

function crBulkCloseModal() {
  return document.getElementById('cr_bulk_close_modal');
}

function crBulkCloseClose() {
  const modal = crBulkCloseModal();
  if (modal && window.jQuery) {
    window.jQuery(modal).foundation('reveal', 'close');
  }
}

function crBulkCloseShowError(message) {
  const modal = crBulkCloseModal();
  if (!modal) {
    return;
  }
  const error = modal.querySelector('#cr_bulk_close_error');
  const select = modal.querySelector('#cr_bulk_close_client_closing_id');
  if (error) {
    error.textContent = message;
    error.style.display = message ? '' : 'none';
  }
  if (message && select && window.jQuery) {
    window.jQuery(select).effect('shake');
  }
}

/**
 * Open the bulk-close modal so the user can pick one Abschlussgrund for all selected CRs.
 *
 * @param {HTMLFormElement} form
 * @return {boolean}
 */
function crBulkCloseOpen(form) {
  const modal = crBulkCloseModal();
  if (!modal || !window.jQuery) {
    return crMarksDoSubmit(form, 'toggle_status');
  }

  crBulkCloseMarksForm = form;
  const select = modal.querySelector('#cr_bulk_close_client_closing_id');
  if (select) {
    select.value = '';
  }
  crBulkCloseShowError('');
  window.jQuery(modal).foundation('reveal', 'open');
  return false;
}

function crBulkCloseConfirm() {
  const modal = crBulkCloseModal();
  const form = crBulkCloseMarksForm;
  if (!modal || !form) {
    return;
  }

  const select = modal.querySelector('#cr_bulk_close_client_closing_id');
  const closingId = select ? (select.value || '') : '';
  const required = modal.getAttribute('data-force-client-closing') === 'true';
  if (required && select && !closingId) {
    crBulkCloseShowError('Bitte wählen Sie einen Abschlussgrund aus');
    return;
  }

  const closingField = form.querySelector('[name="client_closing_id"]');
  if (closingField) {
    closingField.value = closingId;
  }

  crBulkCloseClose();
  crMarksDoSubmit(form, 'toggle_status');
  crBulkCloseMarksForm = null;
}

/**
 * Submit the CR marks form for a bulk action. Uses AJAX on client/employee tabs
 * (`data-cr-marks-ajax`) so the person form's do_submit is not called and the tab stays open.
 *
 * @param {HTMLElement|HTMLFormElement} element button or form
 * @param {string} action toggle_status | set_primary_cr | join_sequences
 * @return {boolean}
 */
function crMarksSubmit(element, action) {
  const form = crMarksFormFrom(element);
  if (!form) {
    return false;
  }
  if (!crMarksFinalCheck(form, action)) {
    return false;
  }

  if (action === 'toggle_status') {
    return crBulkCloseOpen(form);
  }

  crMarksDoSubmit(form, action);
  return false;
}

// Legacy inline handler from _table.html.erb (standalone CR index).
function toggle_marks(formName, selectAllName) {
  const form = document.forms[formName] || document.getElementById('client_responsibility_marks_form');
  if (!form) {
    return;
  }
  const selectAll = form.elements[selectAllName] || form.querySelector('.cr-marks-select-all');
  if (!selectAll) {
    return;
  }
  const counts = crCountMarked(form);
  selectAll.checked = !(counts.total === counts.checked && counts.total > 0);
  crToggleMarks(selectAll);
}

function initClientResponsibilityMarks() {
  if (document.documentElement.dataset.crMarksBound === '1') {
    return;
  }
  document.documentElement.dataset.crMarksBound = '1';

  document.addEventListener('change', function (event) {
    const target = event.target;
    if (!target || !target.classList) {
      return;
    }
    if (target.classList.contains('cr-marks-select-all')) {
      crToggleMarks(target);
      return;
    }
    if (target.classList.contains('cr-mark-checkbox')) {
      crSyncSelectAll(crMarksFormFrom(target));
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('#cr_bulk_close_confirm')) {
      event.preventDefault();
      crBulkCloseConfirm();
      return;
    }
    if (event.target.closest('#cr_bulk_close_cancel')) {
      event.preventDefault();
      crBulkCloseClose();
    }
  });
}

export {
  crToggleMarks,
  crMarksSubmit,
  toggle_marks,
  initClientResponsibilityMarks
};
